var exports = {
  "k": "xe564cbfb--07be48--container",
};

module.exports = exports;
